import { useMemo, useState } from 'react';
import { message } from 'antd';
import { useMutation } from '@apollo/client';
import ADDRESS_DELETE from '../mutations/ADDRESS_DELETE';
  
const useAddressDelete = () => {
    const [ isDeleting, setIsDeleting ] = useState( false );
    const [ deleteMutation ] = useMutation( ADDRESS_DELETE );

    const handleAddressDelete = async ( id ) => {
        setIsDeleting( true );
        
        try {
            const response = await deleteMutation( { variables: { id: id } } );
            setIsDeleting( false ); 
            
            if ( response.data.deleteAddress.success ) {
                return true;
            } else {
                return false;
            }
        } catch ( e ) { 
            console.error( e ); 
            message.error( 'Error deleting address!' );
            setIsDeleting( false );
        }
    };

    return useMemo( () => {
        return {
            isDeleting,
            deleteAddress: handleAddressDelete
        };
    }, [ isDeleting ] );
};

export default useAddressDelete;
